import { Root } from '@radix-ui/react-tooltip';
import { PropsWithChildren } from 'react';

import { TooltipRootProps } from './Tooltip.types';

export function TooltipRoot(props: PropsWithChildren<TooltipRootProps>) {
  return <Root {...props} />;
}
